module.exports = __webpack_public_path__ + "assets/img/side-navigation-month-card-active-ba932939.png";